
export enum ColumnFeatures {
    COMPARISON = 'comparison',
    DIFF = 'diff',
    SPLIT = 'split',
    RANK = 'rank',
    SIMPLEBAR = 'simplebar',
}
